<template>
  <component :is="cIcon" v-if="cIcon" :class="cColor" />
</template>

<script setup lang="ts">
import { type Icon, isIcon } from '@/types/icon';
import type { Color } from '@/types/color';

const props = defineProps<{
  icon: Icon;
  color?: Color;
}>();

const cColor = computed(() => {
  if (!props.color) return '';
  return `icon--${props.color}`;
});

const cIcon = computed<Component | undefined>(() => {
  if (!isIcon(props.icon)) {
    useLogger().warn(`Icon ${props.icon as string} not found`);
    return;
  }

  return defineAsyncComponent<Component>(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    async () => import(`@shared-assets/icons/${props.icon}.svg`)
  );
});
</script>

<style lang="scss" scoped>
$this: '.icon';

#{$this} {
  @include color-variants;
}
</style>
